module.exports = __webpack_public_path__ + "static/media/dat.967d24f3.PNG";